import classNames from 'classnames';
import React, { DetailedHTMLProps, HTMLAttributes, MouseEvent, HTMLAttributeAnchorTarget } from 'react';

import styles from './LinkArea.css';

interface ILinkAreaProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  href: string;
  preventDefault?: boolean;
  target?: HTMLAttributeAnchorTarget;
  rel?: string;
}

export function LinkArea({ href, children, preventDefault, target, rel, ...divProps }: ILinkAreaProps) {
  const onLinkClick = (e: MouseEvent<HTMLAnchorElement>) => {
    if (preventDefault) {
      e.preventDefault();
    }
  };

  return (
    <div {...divProps} className={classNames(styles['container'], divProps.className)}>
      <a href={href} rel={rel} className={styles['link']} onClick={onLinkClick} target={target}>
        <span className={styles['link-area']} />
      </a>
      {children}
    </div>
  );
}
